module.exports = __webpack_public_path__ + "static/media/magic-wand.1ab6862b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/magic-wand.svg
// module id = 3153
// module chunks = 7